// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuWrapper_root__toda4"};